import { createApiRef, useApiHolder } from '@backstage/core-plugin-api';

export interface IdentityAutocompleteConfigApi {
  showUserGroupsFilter: boolean;
}

export const identityAutocompleteConfigApiRef =
  createApiRef<IdentityAutocompleteConfigApi>({
    id: 'plugin.confidence-iam.identity-autocomplete-config',
  });

export const useIdentityAutocompleteConfig =
  (): IdentityAutocompleteConfigApi => {
    const apis = useApiHolder();
    const api = apis.get(identityAutocompleteConfigApiRef);
    return api ?? { showUserGroupsFilter: false };
  };
